import { Box, Modal, styled } from '@mui/material';

interface PdfModalProps {
  file: string | null;
  close: () => void;
}

function PdfModal({ file, close }: PdfModalProps) {
  return (
    <Modal open={!!file} onClose={close}>
      <FrameWrapper>
        {file && (
          <iframe
            src={file}
            width='100%'
            height='100%'
            style={{ border: 'none' }}
            title='PDF Preview'
          />
        )}
      </FrameWrapper>
    </Modal>
  );
}

const FrameWrapper = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  height: '80%',
});

export default PdfModal;
